import { Component, Input } from "@angular/core";
import { User, Community } from "../../../../models";

@Component({
  selector: "del-membership-button",
  templateUrl: "./del-membership-button.component.html",
  styleUrls: [
    "./del-membership-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DelMembershipButtonComponent {
  @Input() currentUser: User;
  @Input() community: Community;
  constructor() {}
  ngOnInit() {}
}
